import { FilterState, BudgetRange, ApiFilterResponse } from '@interfaces/filter.types';
import { buildUrlFromFilters, encodeUrlWithSpaces as encodeUrlWithSpacesUtil } from '@utils/filterTransformUtils';

export interface UrlFilterParams {
  bodyTypes?: string[];
  brand?: string[];
  fuelTypes?: string[];
  transmissions?: string[];
  minPrice?: string;
  maxPrice?: string;
  isExpressDelivery?: string;
  features?: string[];
  sortBy?: string[];
  seatCapacity?: string[];
}

export const parseUrlFilters = (searchParams: URLSearchParams): Partial<FilterState> => {
  const filters: Partial<FilterState> = {};

  const bodyTypes = searchParams.getAll('bodyTypes');
  const segments = searchParams.getAll('segments');
  const allBodyTypes = [...bodyTypes, ...segments];
  if (allBodyTypes.length > 0) {
    filters.body_type = allBodyTypes;
  }

  const brand = searchParams.getAll('brand');
  if (brand.length > 0) {
    filters.brand_model = brand;
  }

  const fuelTypes = searchParams.getAll('fuelTypes');
  if (fuelTypes.length > 0) {
    filters.fuel_type = fuelTypes;
  }

  const transmissions = searchParams.getAll('transmissions');
  if (transmissions.length > 0) {
    filters.transmission = transmissions;
  }

  const minPrice = searchParams.get('minPrice');
  const maxPrice = searchParams.get('maxPrice');
  if (minPrice && maxPrice) {
    filters.budget = {
      min: parseInt(minPrice, 10),
      max: parseInt(maxPrice, 10)
    };
  }

  const isExpressDelivery = searchParams.get('isExpressDelivery');
  if (isExpressDelivery !== null) {
    filters.is_express_delivery = isExpressDelivery === 'true';
  }

  const features = searchParams.getAll('features');
  if (features.length > 0) {
    filters.feature = features;
  }

  const sortBy = searchParams.getAll('sortBy');
  if (sortBy.length > 0) {
    filters.sort_by = sortBy;
  }

  const seatCapacity = searchParams.getAll('seatCapacity');
  if (seatCapacity.length > 0) {
    filters.seat_capacity = seatCapacity;
  }

  return filters;
};

export { buildUrlFromFilters } from '@utils/filterTransformUtils';

const encodeUrlWithSpaces = (urlSearchParams: URLSearchParams): string => {
  return urlSearchParams.toString().replace(/\+/g, '%20');
};

export const updateUrlWithFilters = (
  appliedFilters: FilterState['appliedFilters'], 
  filterOptions: ApiFilterResponse | null = null,
  budgetDefaults?: BudgetRange
) => {
  if (typeof window === 'undefined') return;

  const newSearchParams = buildUrlFromFilters(appliedFilters, filterOptions, budgetDefaults);
  const queryString = encodeUrlWithSpacesUtil(newSearchParams);
  const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`;
  
  window.history.pushState({}, '', newUrl);
};

export const hasUrlFilters = (searchParams: URLSearchParams): boolean => {
  const filterKeys = ['bodyTypes', 'segments', 'brand', 'fuelTypes', 'transmissions', 'minPrice', 'maxPrice', 'isExpressDelivery', 'features', 'sortBy', 'seatCapacity'];
  return filterKeys.some(key => searchParams.has(key));
}; 